export default {
    methods: {
        enableExport() {
            return this.checkPermission(this.acl, 'export');
        },
        allowExportData() {
            return (this.getPanel.allowExportData && this.enableExport) || false;
        },
    }
};